/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAdCampaigns = /* GraphQL */ `
  query GetAdCampaigns(
    $id: [Int]
    $limit: Int
    $offset: Int
    $sorting: [ad_campaign_sort_input]
  ) {
    getAdCampaigns(id: $id, limit: $limit, offset: $offset, sorting: $sorting) {
      ad_campaigns {
        ad_platforms {
          created_at
          id
          name
          updated_at
        }
        budget
        cost_per_action
        cost_per_lead
        created_at
        flight_end_date
        flight_start_date
        id
        name
        spend
        updated_at
      }
      total_count
    }
  }
`;
export const getAdPlatforms = /* GraphQL */ `
  query GetAdPlatforms(
    $id: [Int]
    $limit: Int
    $offset: Int
    $sorting: [ad_platform_sort_input]
  ) {
    getAdPlatforms(id: $id, limit: $limit, offset: $offset, sorting: $sorting) {
      ad_platforms {
        created_at
        id
        name
        updated_at
      }
      total_count
    }
  }
`;
export const getAgentSettings = /* GraphQL */ `
  query GetAgentSettings(
    $filters: [agent_setting_filter_input]
    $id: [Int]
    $limit: Int
    $offset: Int
    $sorting: [agent_setting_sort_input]
  ) {
    getAgentSettings(
      filters: $filters
      id: $id
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      agent_settings {
        agent_executable
        agent_modality
        agent_name
        ai_platform
        created_at
        id
        priority
        supports_agent_prompt
        supports_text_intro
        updated_at
      }
      total_count
    }
  }
`;
export const getAIFeedbacks = /* GraphQL */ `
  query GetAIFeedbacks(
    $filters: [ai_feedback_filter_input]
    $id: [Int]
    $limit: Int
    $offset: Int
    $sorting: [ai_feedback_sort_input]
  ) {
    getAIFeedbacks(
      filters: $filters
      id: $id
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      ai_feedbacks {
        cognito_sub
        created_at
        feedback_text
        id
        question
        rating
        request_id
        response
        updated_at
      }
      total_count
    }
  }
`;
export const getAIPlatforms = /* GraphQL */ `
  query GetAIPlatforms(
    $ai_platform: [String]
    $limit: Int
    $offset: Int
    $sorting: [ai_platform_sort_input]
  ) {
    getAIPlatforms(
      ai_platform: $ai_platform
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      ai_platforms {
        ai_platform
        created_at
        status
        updated_at
      }
      total_count
    }
  }
`;
export const getAllergies = /* GraphQL */ `
  query GetAllergies(
    $captcha_token: String
    $id: [Int]
    $limit: Int
    $offset: Int
    $sorting: [allergy_sort_input]
  ) {
    getAllergies(
      captcha_token: $captcha_token
      id: $id
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      allergies {
        allergen_description
        allergen_type
        cc_allergen_id
        ccid
        created_at
        description
        id
        is_default
        name
        updated_at
      }
      total_count
    }
  }
`;
export const getBookings = /* GraphQL */ `
  query GetBookings(
    $filters: [booking_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $sorting: [booking_sort_input]
  ) {
    getBookings(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      bookings {
        created_at
        email_address
        fh_booked_at
        fh_booking_id
        fh_end_at
        fh_event_pk
        fh_number_booked
        fh_parent_name
        fh_parent_pk
        fh_rebooked_booking_id
        fh_shortname
        fh_start_at
        fh_status
        fh_total_revenue
        id
        name
        phone_number
        subject_id
        updated_at
      }
      rankings {
        contact_id
        id
        row_num
      }
      total_count
    }
  }
`;
export const getCallAnalysis = /* GraphQL */ `
  query GetCallAnalysis {
    getCallAnalysis {
      monthly {
        average_duration_seconds
        dropped
        successful
        total_calls
      }
      weekly {
        average_duration_seconds
        dropped
        successful
        total_calls
      }
      yearly {
        average_duration_seconds
        dropped
        successful
        total_calls
      }
    }
  }
`;
export const getCallOutcomes = /* GraphQL */ `
  query GetCallOutcomes {
    getCallOutcomes {
      monthly {
        answered
        month
        needs_callback
        not_interested
        scheduled
        unanswered
        voicemail
      }
      weekly {
        answered
        month
        needs_callback
        not_interested
        scheduled
        unanswered
        voicemail
      }
      yearly {
        answered
        month
        needs_callback
        not_interested
        scheduled
        unanswered
        voicemail
      }
    }
  }
`;
export const getCompletion = /* GraphQL */ `
  query GetCompletion(
    $async: Boolean
    $button_clicked: String
    $captcha_token: String
    $contact_id: String
    $jwt: String
    $messages: AWSJSON
    $model: String
    $op: String
    $system: AWSJSON
    $transcript: AWSJSON
  ) {
    getCompletion(
      async: $async
      button_clicked: $button_clicked
      captcha_token: $captcha_token
      contact_id: $contact_id
      jwt: $jwt
      messages: $messages
      model: $model
      op: $op
      system: $system
      transcript: $transcript
    ) {
      response
      request_id
    }
  }
`;
export const getConditions = /* GraphQL */ `
  query GetConditions(
    $captcha_token: String
    $id: [Int]
    $limit: Int
    $offset: Int
    $sorting: [condition_sort_input]
  ) {
    getConditions(
      captcha_token: $captcha_token
      id: $id
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      conditions {
        category_description
        category_name
        cc_category_id
        ccid
        created_at
        description
        icd9_code
        id
        is_child_bearing
        name
        updated_at
      }
      total_count
    }
  }
`;
export const getDeals = /* GraphQL */ `
  query GetDeals(
    $filters: [deal_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $sorting: [deal_sort_input]
  ) {
    getDeals(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      deals {
        created_at
        deal_description
        deal_name
        id
        subject_count
        updated_at
      }
      rankings {
        contact_id
        id
        row_num
      }
      total_count
    }
  }
`;
export const getFiles = /* GraphQL */ `
  query GetFiles($deal_id: Int, $key: String, $subject_id: Int) {
    getFiles(deal_id: $deal_id, key: $key, subject_id: $subject_id) {
      files {
        created_at
        key
        key_url
        size
        updated_at
      }
      total_count
    }
  }
`;
export const getMedications = /* GraphQL */ `
  query GetMedications(
    $captcha_token: String
    $id: [Int]
    $limit: Int
    $offset: Int
    $sorting: [medication_sort_input]
  ) {
    getMedications(
      captcha_token: $captcha_token
      id: $id
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      medications {
        category_name
        ccid
        created_at
        default_route_id
        default_route_id_name
        description
        id
        is_child_bearing
        name
        updated_at
      }
      total_count
    }
  }
`;
export const getProtocols = /* GraphQL */ `
  query GetProtocols(
    $filters: [protocol_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $sorting: [protocol_sort_input]
    $subject_id: [Int]
  ) {
    getProtocols(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      sorting: $sorting
      subject_id: $subject_id
    ) {
      protocols {
        created_at
        id
        protocol_bucket
        protocol_extract_json
        protocol_key
        protocol_name
        protocol_url
        subject_count
        subject_exclusion_filters_json
        subject_inclusion_filters_json
        updated_at
      }
      rankings {
        contact_id
        id
        row_num
      }
      total_count
    }
  }
`;
export const getProviderTypes = /* GraphQL */ `
  query GetProviderTypes(
    $captcha_token: String
    $filters: [provider_type_filter_input]
    $limit: Int
    $offset: Int
    $sorting: [provider_type_sort_input]
    $type: [String]
  ) {
    getProviderTypes(
      captcha_token: $captcha_token
      filters: $filters
      limit: $limit
      offset: $offset
      sorting: $sorting
      type: $type
    ) {
      provider_types {
        created_at
        type
        updated_at
      }
      total_count
    }
  }
`;
export const getQueueTasks = /* GraphQL */ `
  query GetQueueTasks(
    $filters: [queue_task_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $sorting: [queue_task_sort_input]
  ) {
    getQueueTasks(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      queue_task {
        alias
        channel
        created_at
        estimated_first_attempt_at
        first_name
        full_name_first
        full_name_last
        id
        last_name
        next_retry_at
        next_task_id
        next_touchpoint
        recruitment_id
        recruitment_source_name
        status
        subject_id
        task_id
        updated_at
        workflow_id
      }
      rankings {
        contact_id
        id
        row_num
      }
      total_count
    }
  }
`;
export const getQuestionnaires = /* GraphQL */ `
  query GetQuestionnaires(
    $filters: [questionnaire_filter_input]
    $id: [Int]
    $limit: Int
    $offset: Int
    $sorting: [questionnaire_sort_input]
  ) {
    getQuestionnaires(
      filters: $filters
      id: $id
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      questionnaires {
        created_at
        description
        id
        name
        questions_json
        settings_json
        subject_count
        subject_abandoned_count
        subject_complete_count
        subject_eligible_count
        subject_ineligible_count
        updated_at
      }
      total_count
    }
  }
`;
export const getRecruitmentSources = /* GraphQL */ `
  query GetRecruitmentSources(
    $filters: [recruitment_source_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $site_id: [Int]
    $sorting: [recruitment_source_sort_input]
    $study_id: [Int]
  ) {
    getRecruitmentSources(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      site_id: $site_id
      sorting: $sorting
      study_id: $study_id
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      recruitment_sources {
        contact_address_line1
        contact_address_line2
        contact_city
        contact_country
        contact_email_address
        contact_name
        contact_phone_number
        contact_postal_code
        contact_state
        created_at
        external_id
        id
        is_deletable
        parent_id
        parent_id_source_description
        parent_id_source_name
        source_description
        source_name
        subject_count
        total_budget
        total_spend
        updated_at
      }
      total_count
    }
  }
`;
export const getRoutes = /* GraphQL */ `
  query GetRoutes(
    $captcha_token: String
    $id: [Int]
    $limit: Int
    $offset: Int
    $sorting: [route_sort_input]
  ) {
    getRoutes(
      captcha_token: $captcha_token
      id: $id
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      routes {
        ccid
        created_at
        id
        name
        updated_at
      }
      total_count
    }
  }
`;
export const getSegments = /* GraphQL */ `
  query GetSegments(
    $filters: [segment_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $sorting: [segment_sort_input]
  ) {
    getSegments(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      segments {
        age_max
        age_min
        allergies {
          allergen_description
          allergen_type
          cc_allergen_id
          ccid
          created_at
          description
          id
          is_default
          name
          updated_at
        }
        bmi_category
        bmi_max
        bmi_min
        conditions {
          category_description
          category_name
          cc_category_id
          ccid
          created_at
          description
          icd9_code
          id
          is_child_bearing
          name
          updated_at
        }
        created_at
        ethnicity
        gender
        height_max_in
        height_min_in
        id
        interaction_frequency
        last_interaction_date
        location_coordinates
        location_radius_miles
        medications {
          category_name
          ccid
          created_at
          default_route_id
          default_route_id_name
          description
          id
          is_child_bearing
          name
          updated_at
        }
        name
        participation_status
        preferred_contact_method
        preferred_language
        previous_trial_participation
        race
        response_status
        smoker_status
        subject_count
        subject_filters_json
        trial_phase
        updated_at
        weight_max_lb
        weight_min_lb
      }
      total_count
    }
  }
`;
export const getSites = /* GraphQL */ `
  query GetSites(
    $filters: [site_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $sorting: [site_sort_input]
  ) {
    getSites(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      sites {
        ccid
        created_at
        id
        site_address_line1
        site_address_line2
        site_city
        site_country
        site_description
        site_name
        site_postal_code
        site_state
        subject_count
        updated_at
      }
      total_count
    }
  }
`;
export const getStudies = /* GraphQL */ `
  query GetStudies(
    $filters: [study_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $sorting: [study_sort_input]
    $site_id: [Int]
  ) {
    getStudies(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      sorting: $sorting
      site_id: $site_id
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      studies {
        agent_booked_appointment_text
        agent_needs_callback_text
        agent_precall_text
        ava_bot_alias_id
        ava_bot_config
        ava_bot_id
        ava_state_machine
        ccid
        contact_flow_id
        created_at
        end_date
        id
        protocol_extract_json
        site_description
        site_id
        site_name
        sponsor_id
        sponsor_name
        start_date
        status
        study_category
        study_cc_visits {
          id
          name
        }
        study_description
        study_name
        subject_count
        subject_protocol_count
        subject_exclusion_filters_json
        subject_inclusion_filters_json
        text_agent_name
        updated_at
        visit_name
        voice_agent_name
      }
      total_count
    }
  }
`;
export const getSubjectAnswers = /* GraphQL */ `
  query GetSubjectAnswers(
    $filters: [subject_answers_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $outcome: [String]
    $questionnaire_id: [Int]
    $sorting: [subject_answers_sort_input]
    $subject_id: [Int]
  ) {
    getSubjectAnswers(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      outcome: $outcome
      questionnaire_id: $questionnaire_id
      sorting: $sorting
      subject_id: $subject_id
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      subject_answers {
        answer
        answered_at
        created_at
        id
        original_answer
        original_question
        outcome
        outcome_description
        question
        questionnaire_id
        source
        subject_id
        updated_at
      }
      total_count
    }
  }
`;
export const getSubjectDealStatusCounts = /* GraphQL */ `
  query GetSubjectDealStatusCounts($deal_id: [Int], $limit: Int, $offset: Int) {
    getSubjectDealStatusCounts(
      deal_id: $deal_id
      limit: $limit
      offset: $offset
    ) {
      subject_deal_status_counts {
        priority
        status
        count
      }
      subject_deal_status_counts_raw {
        priority
        status
        count
      }
    }
  }
`;
export const getSubjectEnrollmentStatusCounts = /* GraphQL */ `
  query GetSubjectEnrollmentStatusCounts(
    $limit: Int
    $offset: Int
    $recruitment_id: [Int]
    $site_id: [Int]
    $study_id: [Int]
  ) {
    getSubjectEnrollmentStatusCounts(
      limit: $limit
      offset: $offset
      recruitment_id: $recruitment_id
      site_id: $site_id
      study_id: $study_id
    ) {
      subject_enrollment_status_counts {
        priority
        status
        count
      }
      subject_enrollment_status_counts_raw {
        priority
        status
        count
      }
    }
  }
`;
export const getSubjectContacts = /* GraphQL */ `
  query GetSubjectContacts(
    $contact_id: [String]
    $filters: [subject_contacts_filter_input]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $outcomes: [String]
    $sorting: [subject_contacts_sort_input]
    $subject_id: [Int]
  ) {
    getSubjectContacts(
      contact_id: $contact_id
      filters: $filters
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      outcomes: $outcomes
      sorting: $sorting
      subject_id: $subject_id
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      subject_contacts {
        ai_platform
        channel
        city
        contact_id
        created_at
        duration_seconds
        ended_at
        first_name
        full_name_first
        full_name_last
        last_name
        next_task_id
        next_touchpoint
        outcome
        outcomes
        phone_number
        purpose
        recording_bucket
        recording_key
        recording_url
        recruitment_id
        recruitment_source_name
        started_at
        subject_id
        summary
        transcript_bucket
        transcript_json
        transcript_key
        transcript_url
        updated_at
        wss_url
      }
      total_count
    }
  }
`;
export const getSubjects = /* GraphQL */ `
  query GetSubjects(
    $contact_outcomes: [String]
    $deal_id: [Int]
    $deal_status: String
    $deal_status_raw: String
    $email_address: String
    $enrollment_status: String
    $enrollment_status_raw: String
    $filters: [subject_filter_input]
    $id: [Int]
    $integrations: GetSubjectsIntegrationsInput
    $is_rankings: Boolean
    $last_contact_outcomes: [String]
    $limit: Int
    $next_task_id: [String]
    $next_touchpoint: [String]
    $offset: Int
    $phone_number: [String]
    $protocol_id: [Int]
    $questionnaire_id: [Int]
    $questionnaire_outcome: [String]
    $recruitment_id: [Int]
    $segment_id: [Int]
    $site_id: [Int]
    $sorting: [subject_sort_input]
    $statuses: [String]
    $study_id: [Int]
    $subject_contacts_limit: Int
    $workflow_id: [Int]
  ) {
    getSubjects(
      contact_outcomes: $contact_outcomes
      deal_id: $deal_id
      deal_status: $deal_status
      deal_status_raw: $deal_status_raw
      email_address: $email_address
      enrollment_status: $enrollment_status
      enrollment_status_raw: $enrollment_status_raw
      filters: $filters
      id: $id
      integrations: $integrations
      is_rankings: $is_rankings
      last_contact_outcomes: $last_contact_outcomes
      limit: $limit
      next_task_id: $next_task_id
      next_touchpoint: $next_touchpoint
      offset: $offset
      phone_number: $phone_number
      protocol_id: $protocol_id
      questionnaire_id: $questionnaire_id
      questionnaire_outcome: $questionnaire_outcome
      recruitment_id: $recruitment_id
      segment_id: $segment_id
      site_id: $site_id
      sorting: $sorting
      statuses: $statuses
      study_id: $study_id
      subject_contacts_limit: $subject_contacts_limit
      workflow_id: $workflow_id
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      subjects {
        active_enrollment_status
        age
        alcohol_use_frequency
        bmi
        ccid
        created_at
        crid
        current_study_id
        current_study_name
        date_of_birth
        diet_type
        ethnicity
        first_name
        full_name_first
        full_name_last
        gender
        height_cm
        height_in
        id
        is_possible_duplicate
        last_contact_outcomes
        last_contact_started_at
        last_name
        last_task_id
        last_touchpoint
        lead_created_at
        lifestyle_notes
        marital_status
        middle_name
        next_appt
        next_task_id
        next_touchpoint
        physical_activity_level
        preferred_language
        q_currently_in_clinical_trial
        q_date_of_last_dose
        q_date_of_last_visit
        q_ever_in_clinical_trial
        race
        ready_to_contact
        recruitment_source_name
        sleep_hours
        smoker_status
        sms_opt_in
        statuses
        stress_level
        subject_addresses {
          address_line1
          address_line2
          city
          country
          created_at
          id
          postal_code
          preferred
          state
          subject_id
          updated_at
        }
        subject_allergies {
          allergy_id
          allergy_id_allergen_description
          allergy_id_allergen_type
          allergy_id_cc_allergen_id
          allergy_id_ccid
          allergy_id_description
          allergy_id_is_default
          allergy_id_name
          allergy_name
          allergy_type
          created_at
          id
          notes
          reaction
          severity
          subject_id
          updated_at
        }
        subject_appointments {
          cc_appointment_id
          cc_patient_id
          cc_proposal_id
          cc_status
          cc_study_id
          created_at
          end_at
          id
          start_at
          subject_id
          updated_at
        }
        subject_contacts {
          ai_platform
          channel
          city
          contact_id
          created_at
          duration_seconds
          ended_at
          first_name
          full_name_first
          full_name_last
          last_name
          next_task_id
          next_touchpoint
          outcome
          outcomes
          phone_number
          purpose
          recording_bucket
          recording_key
          recording_url
          recruitment_id
          recruitment_source_name
          started_at
          subject_id
          summary
          transcript_bucket
          transcript_json
          transcript_key
          transcript_url
          updated_at
          wss_url
        }
        subject_deal_status {
          created_at
          deal_description
          deal_id
          deal_name
          status
          id
          subject_id
          updated_at
        }
        subject_emails {
          created_at
          email_address
          id
          preferred
          subject_id
          updated_at
        }
        subject_emergency_contacts {
          created_at
          email_address
          id
          name
          phone_number
          relationship_to_patient
          subject_id
          updated_at
        }
        subject_enrollment_status {
          ava_bot_alias_id
          ava_bot_config
          ava_bot_id
          ava_state_machine
          ccid
          contact_flow_id
          contact_name
          created_at
          enrollment_status
          id
          notes
          recruitment_id
          source_description
          source_name
          study_ava_bot_alias_id
          study_ava_bot_config
          study_ava_bot_id
          study_ava_state_machine
          study_category
          study_ccid
          study_contact_flow_id
          study_description
          study_enrollment_status_is_complete
          study_enrollment_status_priority
          study_id
          study_name
          study_visit_name
          subject_id
          updated_at
        }
        subject_family_medical_history {
          condition_id
          condition_id_category_description
          condition_id_category_name
          condition_id_cc_category_id
          condition_id_ccid
          condition_id_description
          condition_id_icd9_code
          condition_id_is_child_bearing
          condition_id_name
          condition_name
          created_at
          family_member
          id
          notes
          subject_id
          updated_at
        }
        subject_medical_history {
          condition_id
          condition_id_category_description
          condition_id_category_name
          condition_id_cc_category_id
          condition_id_ccid
          condition_id_description
          condition_id_icd9_code
          condition_id_is_child_bearing
          condition_id_name
          condition_name
          condition_status
          created_at
          diagnosed_date
          id
          notes
          resolved_date
          subject_id
          updated_at
        }
        subject_medications {
          created_at
          dosage_and_frequency
          end_date
          id
          medication_id
          medication_id_category_name
          medication_id_ccid
          medication_id_default_route_id
          medication_id_description
          medication_id_is_child_bearing
          medication_id_name
          medication_name
          notes
          prescribed_by
          reason_for_use
          route_id
          route_id_name
          start_date
          subject_id
          updated_at
        }
        subject_notes {
          created_at
          created_by
          id
          note
          subject_id
          updated_at
        }
        subject_phone_numbers {
          best_days_to_call
          best_time_to_call_end
          best_time_to_call_start
          created_at
          id
          phone_number
          phone_type
          preferred
          sms_opt_in
          subject_id
          updated_at
        }
        subject_physicians {
          address_line1
          address_line2
          city
          country
          created_at
          fax_number
          id
          last_exam_date
          name
          phone_number
          postal_code
          primary
          provider_type
          state
          subject_id
          updated_at
        }
        subject_recruitment_sources {
          created_at
          id
          notes
          recruitment_id
          source_description
          source_name
          subject_id
          updated_at
        }
        subject_statuses {
          created_at
          id
          status
          subject_id
          updated_at
        }
        subject_workflows {
          created_at
          id
          last_task_id
          last_touchpoint
          next_task_id
          next_touchpoint
          subject_id
          tasks_json
          updated_at
          workflow_id
          workflow_name
          workflow_tasks_json
        }
        title
        updated_at
        viewed_active_deal_page
        weight_kg
        weight_lb
      }
      total_count
    }
  }
`;
export const getDistinctSubjectStatuses = /* GraphQL */ `
  query GetDistinctSubjectStatuses {
    getDistinctSubjectStatuses {
      statuses
    }
  }
`;
export const getTableChangelog = /* GraphQL */ `
  query GetTableChangelog(
    $filters: [table_changelog_filter_input]
    $id: [Int]
    $limit: Int
    $offset: Int
    $sorting: [table_changelog_sort_input]
  ) {
    getTableChangelog(
      filters: $filters
      id: $id
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      queue_task {
        alias
        channel
        created_at
        estimated_first_attempt_at
        first_name
        full_name_first
        full_name_last
        id
        last_name
        next_retry_at
        next_task_id
        next_touchpoint
        recruitment_id
        recruitment_source_name
        status
        subject_id
        task_id
        updated_at
        workflow_id
      }
      recruitment_sources {
        contact_address_line1
        contact_address_line2
        contact_city
        contact_country
        contact_email_address
        contact_name
        contact_phone_number
        contact_postal_code
        contact_state
        created_at
        external_id
        id
        is_deletable
        parent_id
        parent_id_source_description
        parent_id_source_name
        source_description
        source_name
        subject_count
        total_budget
        total_spend
        updated_at
      }
      segments {
        age_max
        age_min
        allergies {
          allergen_description
          allergen_type
          cc_allergen_id
          ccid
          created_at
          description
          id
          is_default
          name
          updated_at
        }
        bmi_category
        bmi_max
        bmi_min
        conditions {
          category_description
          category_name
          cc_category_id
          ccid
          created_at
          description
          icd9_code
          id
          is_child_bearing
          name
          updated_at
        }
        created_at
        ethnicity
        gender
        height_max_in
        height_min_in
        id
        interaction_frequency
        last_interaction_date
        location_coordinates
        location_radius_miles
        medications {
          category_name
          ccid
          created_at
          default_route_id
          default_route_id_name
          description
          id
          is_child_bearing
          name
          updated_at
        }
        name
        participation_status
        preferred_contact_method
        preferred_language
        previous_trial_participation
        race
        response_status
        smoker_status
        subject_count
        subject_filters_json
        trial_phase
        updated_at
        weight_max_lb
        weight_min_lb
      }
      sites {
        ccid
        created_at
        id
        site_address_line1
        site_address_line2
        site_city
        site_country
        site_description
        site_name
        site_postal_code
        site_state
        subject_count
        updated_at
      }
      studies {
        agent_booked_appointment_text
        agent_needs_callback_text
        agent_precall_text
        ava_bot_alias_id
        ava_bot_config
        ava_bot_id
        ava_state_machine
        ccid
        contact_flow_id
        created_at
        end_date
        id
        protocol_extract_json
        site_description
        site_id
        site_name
        sponsor_id
        sponsor_name
        start_date
        status
        study_category
        study_cc_visits {
          id
          name
        }
        study_description
        study_name
        subject_count
        subject_protocol_count
        subject_exclusion_filters_json
        subject_inclusion_filters_json
        text_agent_name
        updated_at
        visit_name
        voice_agent_name
      }
      subjects {
        active_enrollment_status
        age
        alcohol_use_frequency
        bmi
        ccid
        created_at
        crid
        current_study_id
        current_study_name
        date_of_birth
        diet_type
        ethnicity
        first_name
        full_name_first
        full_name_last
        gender
        height_cm
        height_in
        id
        is_possible_duplicate
        last_contact_outcomes
        last_contact_started_at
        last_name
        last_task_id
        last_touchpoint
        lead_created_at
        lifestyle_notes
        marital_status
        middle_name
        next_appt
        next_task_id
        next_touchpoint
        physical_activity_level
        preferred_language
        q_currently_in_clinical_trial
        q_date_of_last_dose
        q_date_of_last_visit
        q_ever_in_clinical_trial
        race
        ready_to_contact
        recruitment_source_name
        sleep_hours
        smoker_status
        sms_opt_in
        statuses
        stress_level
        subject_addresses {
          address_line1
          address_line2
          city
          country
          created_at
          id
          postal_code
          preferred
          state
          subject_id
          updated_at
        }
        subject_allergies {
          allergy_id
          allergy_id_allergen_description
          allergy_id_allergen_type
          allergy_id_cc_allergen_id
          allergy_id_ccid
          allergy_id_description
          allergy_id_is_default
          allergy_id_name
          allergy_name
          allergy_type
          created_at
          id
          notes
          reaction
          severity
          subject_id
          updated_at
        }
        subject_appointments {
          cc_appointment_id
          cc_patient_id
          cc_proposal_id
          cc_status
          cc_study_id
          created_at
          end_at
          id
          start_at
          subject_id
          updated_at
        }
        subject_contacts {
          ai_platform
          channel
          city
          contact_id
          created_at
          duration_seconds
          ended_at
          first_name
          full_name_first
          full_name_last
          last_name
          next_task_id
          next_touchpoint
          outcome
          outcomes
          phone_number
          purpose
          recording_bucket
          recording_key
          recording_url
          recruitment_id
          recruitment_source_name
          started_at
          subject_id
          summary
          transcript_bucket
          transcript_json
          transcript_key
          transcript_url
          updated_at
          wss_url
        }
        subject_deal_status {
          created_at
          deal_description
          deal_id
          deal_name
          status
          id
          subject_id
          updated_at
        }
        subject_emails {
          created_at
          email_address
          id
          preferred
          subject_id
          updated_at
        }
        subject_emergency_contacts {
          created_at
          email_address
          id
          name
          phone_number
          relationship_to_patient
          subject_id
          updated_at
        }
        subject_enrollment_status {
          ava_bot_alias_id
          ava_bot_config
          ava_bot_id
          ava_state_machine
          ccid
          contact_flow_id
          contact_name
          created_at
          enrollment_status
          id
          notes
          recruitment_id
          source_description
          source_name
          study_ava_bot_alias_id
          study_ava_bot_config
          study_ava_bot_id
          study_ava_state_machine
          study_category
          study_ccid
          study_contact_flow_id
          study_description
          study_enrollment_status_is_complete
          study_enrollment_status_priority
          study_id
          study_name
          study_visit_name
          subject_id
          updated_at
        }
        subject_family_medical_history {
          condition_id
          condition_id_category_description
          condition_id_category_name
          condition_id_cc_category_id
          condition_id_ccid
          condition_id_description
          condition_id_icd9_code
          condition_id_is_child_bearing
          condition_id_name
          condition_name
          created_at
          family_member
          id
          notes
          subject_id
          updated_at
        }
        subject_medical_history {
          condition_id
          condition_id_category_description
          condition_id_category_name
          condition_id_cc_category_id
          condition_id_ccid
          condition_id_description
          condition_id_icd9_code
          condition_id_is_child_bearing
          condition_id_name
          condition_name
          condition_status
          created_at
          diagnosed_date
          id
          notes
          resolved_date
          subject_id
          updated_at
        }
        subject_medications {
          created_at
          dosage_and_frequency
          end_date
          id
          medication_id
          medication_id_category_name
          medication_id_ccid
          medication_id_default_route_id
          medication_id_description
          medication_id_is_child_bearing
          medication_id_name
          medication_name
          notes
          prescribed_by
          reason_for_use
          route_id
          route_id_name
          start_date
          subject_id
          updated_at
        }
        subject_notes {
          created_at
          created_by
          id
          note
          subject_id
          updated_at
        }
        subject_phone_numbers {
          best_days_to_call
          best_time_to_call_end
          best_time_to_call_start
          created_at
          id
          phone_number
          phone_type
          preferred
          sms_opt_in
          subject_id
          updated_at
        }
        subject_physicians {
          address_line1
          address_line2
          city
          country
          created_at
          fax_number
          id
          last_exam_date
          name
          phone_number
          postal_code
          primary
          provider_type
          state
          subject_id
          updated_at
        }
        subject_recruitment_sources {
          created_at
          id
          notes
          recruitment_id
          source_description
          source_name
          subject_id
          updated_at
        }
        subject_statuses {
          created_at
          id
          status
          subject_id
          updated_at
        }
        subject_workflows {
          created_at
          id
          last_task_id
          last_touchpoint
          next_task_id
          next_touchpoint
          subject_id
          tasks_json
          updated_at
          workflow_id
          workflow_name
          workflow_tasks_json
        }
        title
        updated_at
        viewed_active_deal_page
        weight_kg
        weight_lb
      }
      subject_contacts {
        ai_platform
        channel
        city
        contact_id
        created_at
        duration_seconds
        ended_at
        first_name
        full_name_first
        full_name_last
        last_name
        next_task_id
        next_touchpoint
        outcome
        outcomes
        phone_number
        purpose
        recording_bucket
        recording_key
        recording_url
        recruitment_id
        recruitment_source_name
        started_at
        subject_id
        summary
        transcript_bucket
        transcript_json
        transcript_key
        transcript_url
        updated_at
        wss_url
      }
      table_changelog {
        cognito_sub
        created_at
        field_name
        id
        old_value
        new_value
        request_id
        subject_id
        table_id
        table_name
      }
      total_count
      workflows {
        agent_prompt
        created_at
        description
        id
        is_active
        name
        next_touchpoint_counts_json
        recruitment_id
        recruitment_parent_id
        recruitment_parent_source_name
        recruitment_source_name
        study_id
        study_name
        subject_count
        subject_filters_json
        tasks_json
        text_agent_name
        updated_at
        voice_agent_name
      }
    }
  }
`;
export const getTopLocations = /* GraphQL */ `
  query GetTopLocations($limit: Int) {
    getTopLocations(limit: $limit) {
      monthly {
        area_code
        call_count
        city
      }
      weekly {
        area_code
        call_count
        city
      }
      yearly {
        area_code
        call_count
        city
      }
    }
  }
`;
export const getTopOutreachMethods = /* GraphQL */ `
  query GetTopOutreachMethods {
    getTopOutreachMethods {
      count
      method
    }
  }
`;
export const getTotalOutreach = /* GraphQL */ `
  query GetTotalOutreach {
    getTotalOutreach {
      monthly {
        label
        value
      }
      total
      weekly {
        label
        value
      }
      yearly {
        label
        value
      }
    }
  }
`;
export const getUpcomingAppointments = /* GraphQL */ `
  query GetUpcomingAppointments($limit: Int) {
    getUpcomingAppointments(limit: $limit) {
      appointment_time
      platform
      subject_name
    }
  }
`;
export const getVimeo = /* GraphQL */ `
  query GetVimeo($captcha_token: String, $video_id: String) {
    getVimeo(captcha_token: $captcha_token, video_id: $video_id) {
      summary
      transcript
    }
  }
`;
export const getWaitlists = /* GraphQL */ `
  query GetWaitlists(
    $id: [Int]
    $limit: Int
    $offset: Int
    $sorting: [waitlist_sort_input]
  ) {
    getWaitlists(id: $id, limit: $limit, offset: $offset, sorting: $sorting) {
      waitlists {
        company_name
        created_at
        email_address
        first_name
        id
        last_name
        updated_at
      }
      total_count
    }
  }
`;
export const getWorkflows = /* GraphQL */ `
  query GetWorkflows(
    $filters: [workflow_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $sorting: [workflow_sort_input]
  ) {
    getWorkflows(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      workflows {
        agent_prompt
        created_at
        description
        id
        is_active
        name
        next_touchpoint_counts_json
        recruitment_id
        recruitment_parent_id
        recruitment_parent_source_name
        recruitment_source_name
        study_id
        study_name
        subject_count
        subject_filters_json
        tasks_json
        text_agent_name
        updated_at
        voice_agent_name
      }
      total_count
    }
  }
`;
export const getContactTranscription = /* GraphQL */ `
  query GetContactTranscription($contactId: String!) {
    getContactTranscription(contactId: $contactId) {
      contactId
      createdAt
      transcriptions {
        channelId
        endTime
        startTime
        transcript
      }
      updatedAt
    }
  }
`;
export const listContactTranscriptions = /* GraphQL */ `
  query ListContactTranscriptions(
    $contactId: String
    $filter: ModelContactTranscriptionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listContactTranscriptions(
      contactId: $contactId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        contactId
        createdAt
        transcriptions {
          channelId
          endTime
          startTime
          transcript
        }
        updatedAt
      }
      nextToken
    }
  }
`;
